export default "__VITE_ASSET__e9ccf1b6__"